module.exports = __webpack_public_path__ + "img/contorl.f2c78dc3.png";